module.exports = new __parcel__URL__("frostcrystal.aefa94d7.png").toString();